import React, { useState } from 'react';
import { To, useNavigate } from 'react-router-dom';
import logoImage from '../../assets/images/logoImage.svg';
import {
  IconDashboard,
  IconStethoscope,
  IconBuildingHospital,
  IconBrandApplePodcast,
  IconLogout2,
  IconSettingsHeart,
  IconCircleArrowLeftFilled,
  IconBrandHipchat,
  IconDiscountCheck,
  IconFirstAidKit,
  IconLungs,
  IconCategory2
} from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import colors from '../../constants/colors';
import routes from '../../config/sidebar.json'; // Import the routes JSON file
import './index.css';
import { logout } from '../../utils/logout';
import { BasicButton } from 'components';

const iconMap: { [key: string]: React.ElementType } = {
  IconDashboard,
  IconStethoscope,
  IconBuildingHospital,
  IconBrandApplePodcast,
  IconBrandHipchat,
  IconFirstAidKit,
  IconSettingsHeart,
  IconCategory2,
  IconLungs,
  IconDiscountCheck // Ensure it's mapped
};

const SideNavbar = () => {
  const [selected, setSelected] = useState(() => {
    return localStorage.getItem('selectedSidebarTab') || 'dashboard';
  });
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleSelect = (route: { name: string; path: To | To[] }) => {
    setSelected(route.name);
    localStorage.setItem('selectedSidebarTab', route.name);

    navigate(Array.isArray(route.path) ? route.path[0] : route.path);
  };

  const userRole = localStorage.getItem('userRole');

  const filteredRoutes = routes.filter((route) => route.roles.includes(userRole || ''));

  return (
    <div className="side-nav">
      <div className="upper-navbar">
        <div className="navbar-image">
          <img src={logoImage} alt="not available" className="logo-image" />
        </div>
        <div className="toggle-icon">
          <IconCircleArrowLeftFilled size={30} color={colors.blueBase} />
        </div>
        <div className="navigation-buttons">
          {filteredRoutes.map((item) => {
            const IconComponent = iconMap[item.icon];
            return (
              <div
                key={item.name}
                className={`button-row ${selected === item.name ? 'selected' : ''}`}
                onClick={() => handleSelect(item)}>
                <div className="button-icon">
                  <IconComponent size={20} color={colors.blueDarkText} />
                </div>
                <div className="dashboard-button">
                  <span>{t(item.name)}</span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div className="lower-navbar">
        <div className="divider"></div>
        <div className="logout-button-wrapper">
          <BasicButton
            variant="outlined"
            onClick={async () => {
              await logout();
            }}
            icon={<IconLogout2 size={20} color="#3F3F3F" />}
            label={t('logout')}
          />
        </div>
      </div>
    </div>
  );
};

export default SideNavbar;
